import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import dividuBlue from '../../assets/dividu-blue.svg';

const VerifyEmailPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // Tenta pegar o email do state da navegação ou exibe erro se não houver
    const email = location.state?.email;

    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!email) {
            navigate('/register');
        }
    }, [email, navigate]);

    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 6);
        setCode(value);
        if (error) setError('');
    };

    const handleVerify = async (e) => {
        e.preventDefault();

        if (!code || code.length < 6) {
            setError('Digite o código de 6 dígitos.');
            return;
        }

        setLoading(true);
        setError('');

        try {
            await authService.verify(email, code);
            navigate('/groups');
        } catch (err) {
            setError(err.response?.data?.message || 'Código inválido ou expirado.');
        } finally {
            setLoading(false);
        }
    };

    const handleResend = async () => {
        if (loading) return;

        setLoading(true);
        setError('');
        setMessage('');

        try {
            await authService.resendCode(email);
            setMessage('Código reenviado! Verifique seu email.');
        } catch (err) {
            setError('Erro ao reenviar código.');
        } finally {
            setLoading(false);
        }
    };

    if (!email) return null;

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    {/* Logo */}
                    <div className="auth-logo">
                        <img src={dividuBlue} alt="Dividu" style={{ height: '70px', width: 'auto' }} />
                    </div>

                    {/* Title */}
                    <h1 className="auth-title">Verificar Email</h1>
                    <p className="auth-subtitle">
                        Enviamos um código para <br />
                        <strong>{email}</strong>
                    </p>

                    {/* Alerts */}
                    {error && (
                        <div className="alert alert-error">
                            <span>⚠️</span>
                            {error}
                        </div>
                    )}
                    {message && (
                        <div className="alert alert-success" style={{ backgroundColor: '#D1FAE5', color: '#065F46', padding: '12px', borderRadius: '8px', marginBottom: '20px', display: 'flex', gap: '8px', alignItems: 'center', fontSize: '14px' }}>
                            <span>✅</span>
                            {message}
                        </div>
                    )}

                    {/* Form */}
                    <form onSubmit={handleVerify}>
                        <div className="form-group">
                            <label className="form-label">Código de Verificação</label>
                            <input
                                type="text"
                                className="form-input"
                                value={code}
                                onChange={handleChange}
                                placeholder="000000"
                                style={{
                                    textAlign: 'center',
                                    fontSize: '24px',
                                    letterSpacing: '8px',
                                    fontWeight: 'bold',
                                    fontFamily: 'monospace'
                                }}
                                required
                                autoFocus
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary btn-block btn-lg"
                            disabled={loading || code.length < 6}
                        >
                            {loading ? (
                                <>
                                    <span className="loading-spinner" style={{ width: 20, height: 20, borderWidth: 2 }}></span>
                                    Verificando...
                                </>
                            ) : (
                                'Verificar Código'
                            )}
                        </button>
                    </form>

                    {/* Resend */}
                    <div className="auth-footer">
                        Não recebeu o código?{' '}
                        <button
                            onClick={handleResend}
                            className="btn-link"
                            style={{
                                border: 'none',
                                background: 'none',
                                color: '#6366F1',
                                cursor: 'pointer',
                                fontWeight: 600,
                                padding: 0,
                                fontFamily: 'inherit'
                            }}
                            disabled={loading}
                        >
                            Reenviar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmailPage;
